import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BreadCrumbs } from '@codametrix/ui-components';
import history from '../../history';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Route, Switch, useLocation } from 'react-router-dom';
import paths from './paths';
//exported for testing
export const BreadCrumbsRoutes = (props)=>{
    const { state, path, handleActiveCrumbClick, routes } = props;
    const handleSelect = (data)=>{
        const parts = path.split('/');
        handleActiveCrumbClick(parts.slice(0, data.split('/').length - 1).join('/'));
    };
    const breadCrumbs = routes.map((route)=>{
        return /*#__PURE__*/ _jsx(Route, {
            exact: true,
            path: route.path,
            render: (props)=>{
                const crumbs = routes//Get parent paths of the current path ie: /cmx/users is parent of /cmx/users/:userId
                .filter(({ path })=>props.match.path.includes(path))//Set display name of some breadcrumbs dynamically
                .map((crumb)=>{
                    const { getDisplayName } = crumb;
                    const paths = path.split('/');
                    const dataIndex = parseInt(paths[paths.length - 2]);
                    return getDisplayName ? {
                        ...crumb,
                        displayName: getDisplayName(state, dataIndex)
                    } : crumb;
                })// Create Breadcrumb objects
                .map((crumb, index, arr)=>{
                    const { displayName, path } = crumb;
                    return {
                        displayName,
                        data: path,
                        display: true,
                        link: index + 1 < arr.length ? true : false
                    };
                });
                return /*#__PURE__*/ _jsx(BreadCrumbs, {
                    path: crumbs,
                    onSelect: handleSelect
                });
            }
        });
    });
    return /*#__PURE__*/ _jsxs("span", {
        className: 'qa-bread-crumb-route',
        children: [
            breadCrumbs,
            " "
        ]
    });
};
const BreadCrumbsComponent = ()=>{
    const path = useLocation().pathname;
    const state = useSelector((state)=>({
            dictionaryValues: state.dictionaryValues,
            externalApplications: state.externalApplications,
            organization: state.organization,
            users: state.users
        }), shallowEqual);
    const handleActiveCrumbClick = (data)=>{
        history.push(data);
    };
    return /*#__PURE__*/ _jsx(Switch, {
        children: /*#__PURE__*/ _jsx(BreadCrumbsRoutes, {
            state: state,
            path: path,
            handleActiveCrumbClick: handleActiveCrumbClick,
            routes: paths
        })
    });
};
export default BreadCrumbsComponent;
